export default function Services() {
  const services = [
    {
      id: 'cuadros',
      title: 'Cuadros y Marquetería',
      description: 'Enmarcación personalizada para diplomas, certificados y obras artísticas con marcos de excelente calidad.',
      detail: 'Enmarcación personalizada',
      image: 'https://public.readdy.ai/ai/img_res/1d556cf44fd5802b6f8f4c8d206f3af1.jpg',
      buttonStyle: 'solid'
    },
    {
      id: 'pinturas',
      title: 'Pinturas al Óleo',
      description: 'Obras originales elaboradas artesanalmente y pinturas por encargo adaptadas a tus gustos y necesidades.',
      detail: 'Obras originales y por encargo',
      image: 'https://readdy.ai/api/search-image?query=Original%20handcrafted%20oil%20paintings%20on%20canvas%20with%20rich%20textures%20and%20vibrant%20colors%2C%20artistic%20studio%20setting%20with%20multiple%20finished%20artworks%2C%20professional%20fine%20art%20oil%20painting%20technique%20showing%20brushwork%20detail%2C%20custom%20commissioned%20artwork%20in%20progress%2C%20gallery-quality%20paintings%20with%20artistic%20composition&width=400&height=500&seq=service-oil-paintings-1&orientation=portrait',
      buttonStyle: 'outline'
    },
    {
      id: 'cursos',
      title: 'Cursos de Pintura',
      description: 'Clases de pintura al óleo para principiantes y avanzados, enseñando técnicas y desarrollo creativo.',
      detail: 'Para principiantes y avanzados',
      image: 'https://readdy.ai/api/search-image?query=Art%20class%20studio%20with%20students%20learning%20oil%20painting%20techniques%2C%20instructor%20teaching%20painting%20methods%20with%20easels%20and%20canvases%2C%20creative%20workshop%20environment%20with%20art%20supplies%20and%20materials%2C%20personalized%20art%20education%20setting%20with%20warm%20lighting%2C%20beginner-friendly%20painting%20course%20atmosphere&width=400&height=500&seq=service-courses-1&orientation=portrait',
      buttonStyle: 'outline'
    }
  ];

  return (
    <section className="py-40 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-24">
          <h2 className="text-7xl font-extralight text-gray-900 mb-6">Nuestros Servicios</h2>
          <p className="text-xl text-gray-600">Especialidades artesanales</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {services.map((service) => (
            <div key={service.id} id={service.id} className="group cursor-pointer">
              <div className="bg-white rounded-[32px] overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="h-96 w-full overflow-hidden rounded-t-[32px]">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-10 text-center">
                  <h3 className="text-3xl font-semibold text-gray-900 mb-5">{service.title}</h3>
                  <p className="text-lg text-gray-600 mb-8 leading-relaxed">{service.description}</p>
                  
                  <a
                    href="#contacto"
                    className={`inline-block px-10 py-4 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer ${
                      service.buttonStyle === 'solid'
                        ? 'bg-gray-900 text-white hover:bg-gray-800'
                        : 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'
                    }`}
                  >
                    Ver detalles
                  </a>
                  
                  <p className="text-base text-gray-400 mt-5">{service.detail}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
